exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:640px){.form-1[data-v-3a647c6b]{grid-template-columns:repeat(3,minmax(0,1fr))}}@media (min-width:640px){.form-2[data-v-3a647c6b]{grid-template-columns:repeat(2,minmax(0,1fr))}}@media (min-width:1024px){.form-2[data-v-3a647c6b]{grid-template-columns:repeat(4,minmax(0,1fr))}}@media (min-width:640px){.form-3[data-v-3a647c6b]{grid-template-columns:repeat(2,minmax(0,1fr))}}@media (min-width:1024px){.form-3[data-v-3a647c6b]{grid-template-columns:repeat(4,minmax(0,1fr))}}", ""]);

// exports
